export default __webpack_public_path__ + "6343642e25d2613d7cf3edc2699422b1.png";